import React from 'react';
import { stats } from '../mock';
import CountUp from './CountUp';

export default function GlobalBenchmark() {
  return (
    <section id="global-benchmark" className="bg-[#0b0b0b] text-white">
      <div className="py-24 md:py-28 px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2
            className="text-4xl md:text-5xl mb-8 leading-tight"
            style={{ fontFamily: 'Playfair Display, serif', fontWeight: 400 }}
          >
            A Global Benchmark in Modern Luxury
          </h2>
          <p className="text-white/80 text-sm md:text-base leading-relaxed mb-16 max-w-2xl mx-auto">
            Hunt Global Collective reflects the future of luxury — borderless, culturally fluent,
            and guided by discretion and sophistication. With advisors across premier U.S. markets and
            more than twenty countries, we unite local mastery with global perspective.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-6">
            {stats.map((s) => (
              <div key={s.label} className="text-center">
                <CountUp
                  value={s.value}
                  className="text-5xl md:text-6xl mb-2 block"
                  style={{ fontFamily: 'Playfair Display, serif', fontWeight: 400 }}
                />
                <div className="h-px w-8 bg-[#b39869] mx-auto mb-3" />
                <div className="text-[11px] tracking-[0.35em] uppercase text-white/80">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
